import useGetGuidebookAccessUrl from 'hooks/guidebook/useGetGuidebookAccessUrl';
import { FetchIntegrationAccess } from 'utils/integrations/integrationAccessUrl';

/**
 * Guidebooks access URL as a `FetchIntegrationAccess`: it comes from a
 * dedicated endpoint rather than from the integration agency settings.
 */
const useGuidebookIntegrationAccess = () => {
  const { getGuidebookAccessUrl, isFetching } = useGetGuidebookAccessUrl();

  const fetchAccessUrl: FetchIntegrationAccess = async () => {
    const { data, isError } = await getGuidebookAccessUrl();

    return isError || !data?.url
      ? { status: 'unavailable' }
      : { status: 'available', accessUrl: data.url };
  };

  return { isFetching, fetchAccessUrl };
};

export default useGuidebookIntegrationAccess;
